import React from 'react';
import styled from '@emotion/styled';
// --- external imports -----

import bgProjection from '~/assets/images/baseAssets/modalBg.png';
import bgProjectionRed from '~/assets/images/baseAssets/modalBgRed.png';
// --- internal imports -----

import Asset from './BaseAssets';
import PopupModalContainer from './PopupModalContainer';
// --- local imports -----

function PopupModalBase(props) {
	const scale = props.scale || 1;
	const fontSize = props.fontSize ?? 44;
	const titleVerticalOffSet = props.titleVerticalOffSet ?? 0;
	const hasRedBg = props.redBg ?? false;

	return (
		<PopupModalContainer
			data-testid={props['data-testid']}
		>
			<Asset.Img
				x={(373 * scale) + (props.fhdXOffset ?? 0)}
				y={(258 * scale) + (props.fhdYOffset ?? 0)}
				projection={hasRedBg ? bgProjectionRed : bgProjection}
				scale={scale}
			/>
			<PopupHeader
				x={(425 * scale) + (props.fhdXOffset ?? 0) + (props.titleHorizontalOffSet ?? 0)}
				y={((225 + titleVerticalOffSet) * scale) + (props.fhdYOffset ?? 0)}
				fontSize={fontSize * scale}
				fontFamily={props.fontFamily ?? 'Keys of Paradise'}
				color={props.color}
				textShadow={props.textShadow}
			>
				{props.title}
			</PopupHeader>

			{props.children}
		</PopupModalContainer>
	);
}

const PopupHeader = styled(Asset.Text)`
	color: ${({ color }) => color ? color : '#fbd743'};
	line-height: 1.69;
	text-shadow: ${({ textShadow }) => textShadow ?? '-0.09em 0.045em 0 #d63b25'};
	font-family: ${({ fontFamily }) => fontFamily};
`;

export default PopupModalBase;
